import * as React from 'react';
import type { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import type { SaveClientFlags } from '@sdk/authentication/types';

import { NpsSurveyProvider } from '@web/components/npsScore/NpsSurveyProvider/NpsSurveyProvider';

import PopupSurveyContainer from '../survey/PopupSurveyContainer';
import SurveyCloseButton from '../survey/SurveyCloseButton';

import NpsScoreSteps from './NpsScoreSteps/NpsScoreSteps';
import { useNpsScore } from './npsScore.hooks';

export type Props = {
  children: React.ReactNode;
  user: AuthUserType;
  usersCount: number;
  locationsCount: number;
  subscriptionName: string;
  saveClientFlags: SaveClientFlags;
  forceDisplay: boolean;
  onClose?: () => void;
};

const NpsRate = (props: Props) => {
  const { close, isVisible, onPositiveRate, setSubmitted } = useNpsScore(props);

  if (!isVisible) {
    return null;
  }

  return (
    <PopupSurveyContainer>
      <SurveyCloseButton onClose={close} />
      <NpsScoreSteps
        submitForm={(): void => setSubmitted(true)}
        closeNps={close}
        onPositiveRate={onPositiveRate}
      />
    </PopupSurveyContainer>
  );
};

const NpsRateWrapper = (props: Props) => (
  <NpsSurveyProvider>
    <NpsRate {...props} />
  </NpsSurveyProvider>
);
export default NpsRateWrapper;
